<mat-expansion-panel
  id="youSavePanelID"
  *ngIf="totalDiscount && totalDiscount > 0"
  class="custom-header"
  hideToggle="true"
  #youSave
>
  <mat-expansion-panel-header>
    <mat-panel-title fxLayoutAlign="center center">
      <span class="green"
        >{{ 'add_cart.you_save' | translate }}: {{ totalSave | pricify }}
      </span>
      <mat-icon>info</mat-icon>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div class="advantage-content">
    <div fxLayout="row" class="" *ngIf="price" fxLayoutGap="20px">
      <p fxFlex="50%" align="left" class="blue">{{ priceText }}</p>
      <p fxFlex="50%" align="right" class="blue">
        <span *ngIf="vendor_price">- </span>
        <span *ngIf="!vendor_price">&nbsp; </span>
        {{ vendorPrice | pricify }}
      </p>
    </div>
    <div
      fxLayout="row"
      class=""
      *ngIf="totalSave && totalSave > 0"
      fxLayoutGap="20px"
    >
      <p fxFlex="50%" align="left" class="blue">{{ discountedPriceText }}</p>
      <p fxFlex="50%" align="right" class="blue">{{ lixPrice | pricify }}</p>
    </div>
  </div>
  <mat-divider></mat-divider>
</mat-expansion-panel>
